<template>
    <section class="section iv intro stage i03">
        <div class="pageBox">
            <div class="intro-main">
                <div class="intoheader headlines">
                    <h1 class="headline headline--1">
                        <span class="label">Willkommen bei deinem persönlichen Gründungs&shy;assistenten</span>
                    </h1>
                </div>
                <div class="introtext">
                    <div class="bodytext">
                        <p>
                            Welche Gründungsunterlagen sind notwendig? Bei welchen Ämtern und Behörden muss die
                            Anmeldung erfolgen? Und was ist für deine erfolgreiche Gründung noch nötig?
                        </p>
                        <p>
                            Der digitale Gründungsassistent passt sich deiner individuellen Gründungssituation an und
                            gibt dir einen maßgeschneiderten Fahrplan für deinen Start.
                        </p>
                    </div>
                    <button class="btn btn-big" @click="startApp" v-bind:class="{ hidden: introAccepted }">
                        Jetzt loslegen
                    </button>
                </div>
            </div>

            <div class="intro-hint" v-if="ad">
                <span class="box-label">Unterstützt von unserem Partner</span>
                <div class="gruendercockpit-hint aa01">
                    <div class="inner">
                        <div class="logo">
                            <img :src="ad['logo']" :alt="ad.title" />
                        </div>
                        <div class="side-content">
                            <h3 class="headline headline--4">{{ ad.title }}</h3>
                            <a
                                :href="ad.link.target"
                                class="btn btn--fullwidth btn--small"
                                rel="nofollow"
                                target="_blank"
                            >
                                <span class="label">{{ ad.link.label }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="stage__footer iv in-view">
            <div class="pageBox pb--illu">
                <div class="stage__illustration illu02">
                    <img
                        src="@/assets/illu_man.svg"
                        width="168"
                        height="170"
                        alt=""
                        loading="eager"
                        style="min-width: 5rem"
                    />
                </div>
                <div class="stage__wave">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1440"
                        height="74.36"
                        viewBox="0 0 1440 74.36"
                        preserveAspectRatio="xMidYMid slice"
                    >
                        <path
                            fill="#f1f3f4"
                            d="M1440,3.99c-107.36-11.15-306.91,2.16-373.41,26.33-13.5,4.41-29.32,8.93-44.72,11.36-38.75,6.03-71.55,6.24-113.8,5.52-68.55-1.12-135.78-11.28-202.77-16.95-67.48-5.53-159.09-28.8-222.93-8.23-57.22,22.03-157.78,18.2-224.4,14.6-39.96-2.38-80.53-5.78-119.6-7.18C106.63,27.37,0,28.13,0,43.05c0,0,0,31.31,0,31.31H1440"
                        ></path>
                    </svg>
                </div>
            </div>
        </div>
    </section>
    <transition name="fade">
        <div class="p4b-gruendercockpit-wrap" v-if="introAccepted">
            <div class="controls">
                <div class="pageBox">
                    <form>
                        <Controls :data="apiData['steps']" :control-callback="recieveUserSelection" />
                    </form>
                </div>
            </div>
            <div class="steps">
                <div class="fade" v-if="ready">
                    <div class="preloader">
                        <span>
                            <svg class="spinner" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="50" cy="50" r="45"></circle>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="pageBox is-hidden">
                    <Steps v-if="steps" :steps="filterSteps(steps)" />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Controls from '@/components/Controls'
import Steps from '@/components/Steps'

export default {
    name: 'Main',
    components: { Steps, Controls },
    data() {
        return {
            introAccepted: false,
            ready: false,
            apiData: null,
            steps: null,
            userData: null,
            ad: null,
        }
    },
    mounted() {
        if (window.$adCockpit) {
            this.ad = window.$adCockpit
            console.log('adCockpit', this.ad)
        }
        fetch(`${process.env.VUE_APP_URL_BASE}`)
            .then((res) => res.json())
            .then((data) => {
                this.apiData = data
                this.ready = true
                console.groupCollapsed('apiData 📡')
                console.log('apiData', this.apiData)
                console.groupEnd()
            })
            .catch((err) => console.log(err))
    },

    methods: {
        startApp() {
            this.introAccepted = true
        },
        recieveUserSelection(d) {
            this.userData = d
            if (this.userData.legalForm) {
                if (Object.prototype.hasOwnProperty.call(d.legalForm, 'steps')) {
                    this.steps = Object.values(d.legalForm.steps)
                    for (const step of this.steps) {
                        if (step.checkbox) {
                            Object.assign(step, { show: false })
                        } else {
                            Object.assign(step, { show: true })
                        }
                    }
                    if (Object.entries(this.userData.selectedCheckBoxes).length) {
                        for (const [key, value] of Object.entries(this.userData.selectedCheckBoxes)) {
                            const matchingStep = this.steps.find((step) => {
                                return step.uid === parseInt(key)
                            })
                            Object.assign(matchingStep, { show: value === 'true' })
                        }
                    }
                }
            }
        },
        filterSteps(steps) {
            const fade = document.querySelector('.fade')
            const container = document.querySelector('.steps .pageBox')
            container.classList.add('is-hidden')
            setTimeout(function () {
                container.classList.remove('is-hidden')
            }, 1000)
            fade.classList.add('is-visible')
            setTimeout(function () {
                fade.classList.remove('is-visible')
            }, 1000)

            const filteredSteps = steps.filter((step) => {
                return step.show
            })
            // push ad to filteredSteps if ad exists
            if (this.ad) {
                // add ad to filteredSteps after the third step
                filteredSteps.splice(3, 0, this.ad)
            }
            return filteredSteps
        },
    },
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
    max-height: 20rem;
    transition: all 0.35s ease-out, transform 0.25s 0.1s ease-out;
}

.fade-enter-from,
.fade-leave-to {
    max-height: 0;
    opacity: 0;
}
</style>
